export interface ILoginRequest {
    Username: string;
    Password: string;
    Checksum: string;
    CheckEmpty(): boolean;
}

export class LoginRequest implements ILoginRequest {

    public Username: string;
    public Password: string;
    public Checksum: string;
    public DeviceID: string;

    public CheckEmpty(): boolean {

        if (this.Username === '' || this.Password === '')
            return false;
        else
            return true;

    }

}
